import React from 'react';
import Heading from '../Headings/Headings'


const Message = ({ children, error, success, noShow}) => {
    return ( 
        <Heading size="p" error={error} success={success} noShow={noShow}>
            {children}
        </Heading>
     );
}
 
export default Message; 